export default {
  filters: {
    formatDate: function (time) {
      let t = time || ''
      let matched = t.match(/^\d{4}-\d{2}-\d{2}/i) || []
      return matched.length ? matched[0] : ''
    }
  }
}
